import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="nav-logo">
              Luxury<span>Car</span>LA
            </Link>
            <p>
              Premium black car transportation service in Los Angeles.
              Elegance, safety, and punctuality on every ride.
            </p>
          </div>

          <div className="footer-col">
            <h4>Navigate</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/fleet">Our Fleet</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About Us</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services">Airport Transfers</Link></li>
              <li><Link to="/services">Corporate Travel</Link></li>
              <li><Link to="/services">Weddings & Events</Link></li>
              <li><Link to="/services">Hourly Charter</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <a href="tel:8189154566" className="footer-phone">(818) 915-4566</a>
            <a href="tel:8183559929" className="footer-phone">(818) 355-9929</a>
            <p style={{ marginTop: 12, fontSize: '0.8rem', color: 'var(--text-muted)' }}>
              Los Angeles, California<br />
              Available 24/7
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} LuxuryCarLA. All rights reserved.</p>
          <a
            href="https://softangeles.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginTop: '14px', opacity: 0.9, fontSize: '15px', fontWeight: 500, textDecoration: 'none', color: '#ffffff' }}
          >
            <span>Powered by</span>
            <img src="https://softangeles.com/logo-wide.png" alt="SoftAngeles" style={{ height: '30px', width: 'auto' }} />
          </a>
          <p>Serving Greater Los Angeles</p>
        </div>
      </div>
    </footer>
  );
}
